import Vue from 'vue'
import { isNull } from '@/utils'
import getTranslation from '@/i18n/getTranslation'
import { BILLING_TYPE_MAP } from '@/utils/constant.js'

Vue.filter('limiteStr', (str, count) => {
  if (isNull(str)) {
    return '-'
  } else if (str.length > count) {
    return str.slice(0, count) + '...'
  } else {
    return str
  }
})

Vue.filter('filterParams', val => {
  if (isNull(val)) {
    return '--'
  }
  return val
})

Vue.filter('formatMoney', number => {
  number = number || 0
  number = typeof number !== 'number' ? Number(number) : number
  number = isNaN(number) ? 0 : number
  var _thousand = ',',
    _decimal = '.'
  var negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(2)), 10) + '',
    j = (j = i.length) > 3 ? j % 3 : 0
  return (
    negative +
    (j ? i.substr(0, j) + _thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + _thousand) +
    _decimal +
    Math.abs(number - i)
      .toFixed(2)
      .slice(2)
  )
})

Vue.filter('IETimeFormat', str => {
  if (isNull(str)) {
    return '--'
  }
  var kms = str
  if (typeof kms === 'string') {
    return kms
  } else {
    var date_obj = {}
    var dates = new Date(kms)
    date_obj.yr = dates.getFullYear()
    date_obj.mth = dates.getMonth() + 1
    date_obj.dt = dates.getDate()
    date_obj.tm = dates.getHours()
    date_obj.mn = dates.getMinutes()
    date_obj.sm = dates.getSeconds()
    date_obj.forYM =
      date_obj.yr +
      getTranslation('年') +
      (date_obj.mth < 10 ? '0' + date_obj.mth : date_obj.mth) +
      getTranslation('月')
    date_obj.txt_YMDHM =
      date_obj.yr +
      '-' +
      (date_obj.mth < 10 ? '0' + date_obj.mth : date_obj.mth) +
      '-' +
      (date_obj.dt < 10 ? '0' + date_obj.dt : date_obj.dt) +
      '  ' +
      (date_obj.tm < 10 ? '0' + date_obj.tm : date_obj.tm) +
      ':' +
      (date_obj.mn < 10 ? '0' + date_obj.mn : date_obj.mn) +
      ':' +
      (date_obj.sm < 10 ? '0' + date_obj.sm : date_obj.sm)

    return date_obj.txt_YMDHM
  }
})

export function Region(val) {
  switch (val) {
    case 'all':
      return getTranslation('全部')

    case 'cn-north-1':
      return getTranslation('华北-北京')

    case 'bj_02':
      return getTranslation('华北-北京')

    case 'hb':
      return getTranslation('华北-北京')

    case 'sq_02':
      return getTranslation('华东-宿迁')

    case 'hd':
      return getTranslation('华东-宿迁')

    case 'cn-east-1':
      return getTranslation('华东-宿迁')

    case 'cn-east-2':
      return getTranslation('华东-上海')

    case 'cn-south-1':
      return getTranslation('华南-广州')

    case 'gz_02':
      return getTranslation('华南-广州')

    case 'gz':
      return getTranslation('华南-广州')

    case 'cn-east-9':
      return getTranslation('华东-宿迁9')

    default:
      return ''
  }
}
Vue.filter('filterRegion', val => {
  let regionList = val && val.split('|')
  let regionName = ''
  let regions = new Set() || []
  regionList &&
    regionList.forEach(item => {
      regions.add(Region(item))
    })
  regionName = [...regions].join(',')
  regionName = regionName && regionName.substr(1)
  return regionName
})

Vue.filter('filterBillingType', billType => {
  // 处理计费类型
  if (!billType) return ''
  let bT = billType.value
  let length = BILLING_TYPE_MAP.length - 1
  let billingTypeInfo = ''
  for (let i = length; i >= 0; i--) {
    let type = BILLING_TYPE_MAP[i].value && bT - BILLING_TYPE_MAP[i].value
    if (type >= 0) {
      bT = type
      billingTypeInfo += getTranslation(BILLING_TYPE_MAP[i].label) + ','
    }
  }
  billingTypeInfo = billingTypeInfo.substring(0, billingTypeInfo.length - 1)
  return billingTypeInfo
})

Vue.filter('filterQuotaCouponStatus', val => {
  switch (val) {
    case 1:
      return getTranslation('生成中')
    case 2:
      return getTranslation('禁用')
    case 3:
      return getTranslation('启用')
    case 4:
      return getTranslation('未激活')
    case 5:
      return getTranslation('审批驳回')
    default:
      return getTranslation('未知')
  }
})

Vue.filter('filterOperationTypeIndex', type => {
  switch (type) {
    case 0:
      return getTranslation('未知')
    case 1:
      return getTranslation('发放券额')
    case 2:
      return getTranslation('发放代金券')
    case 3:
      return getTranslation('转赠券额')
    case 4:
      return getTranslation('券额禁用')
    case 5:
      return getTranslation('代金券禁用')
    default:
      return getTranslation('未知')
  }
})

Vue.filter('filterAppcode', name => {
  let appName = ''
  appName = ''
  if (!name) return '--'
  let aN = name.split(',')
  aN &&
    aN.map(item => {
      appName += getTranslation(item) + ','
    })
  appName = appName.substring(0, appName.length - 1)
  return appName
})

/**
 * 客户敏感信息加密
 *
 * @param {String} val 需要加密的字符串
 * @param {String} leftLen 字符串左边保留的位数
 * @param {*} rightLen 字符串右边保留的位数
 * @memberof baseService
 */
Vue.filter('codeString', (val, leftLen, rightLen) => {
  if (isNull(val)) {
    return '--'
  }
  let len = val.length - leftLen - rightLen
  let code = ''
  if (len > 0) {
    for (let i = 0; i < len; i++) {
      code += '*'
    }
    return (
      val.substring(0, leftLen) + code + val.substring(val.length - rightLen)
    )
  } else {
    return val
  }
})

Vue.filter('filterPayType', type => {
  switch (type) {
    case 1:
      return getTranslation('生成中')
    case 2:
      return getTranslation('生成')
    case 3:
      return getTranslation('发放')
    case 4:
      return getTranslation('支付')
    case 5:
      return getTranslation('激活')
    case 6:
      return getTranslation('绑定')
    case 7:
      return getTranslation('过期')
    case 8:
      return getTranslation('废除')
    case 9:
      return getTranslation('返还')
    case 10:
      return getTranslation('退款')
    case 0:
      return getTranslation('未知')
    default:
      return '--'
  }
})
